import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { IdPrefixContext } from "../../helpers/idPrefixContext";

export default function ProductOptionImagePill({
  optionValue,
  optionName,
  disabled,
  updateOptionValue,
  selected,
}) {
  const idPrefix = useContext(IdPrefixContext);
  const image = optionValue.orientationImage?.image;

  return (
    <label className="product-options__image-pill-wrapper">
      <input
        type="radio"
        name={`${idPrefix}${optionName}`}
        value={optionValue.name}
        className="product-options__image-pill-input"
        onChange={(e) => updateOptionValue(e.target.value)}
        checked={selected}
      />
      <div className="product-options__image-pill">
        <div
          className={`product-options__image-pill-inner ${disabled ? "product-options__image-pill-inner--disabled" : ""}`}
        >
          <span className="product-options__image-pill-label">
            {optionValue.name}
          </span>
          {image && (
            <img
              className="product-options__image-pill-image"
              src={window.getSizedImageUrl(image.url, "200x")}
              width={image.width}
              height={image.height}
              alt=""
              loading="lazy"
            />
          )}
          {disabled && (
            <div className="product-options__image-pill-disabled-slash"></div>
          )}
        </div>
      </div>
    </label>
  );
}
